/* remy-winter-chart.js -- HAND-AUTHORED (theme-src/, 2026-10-18). Store-only.
   Opens the winter size chart that snippets/winter-size-chart.liquid renders inline
   on the product page. It reuses the .sg modal look from styles.css but not
   script.js's handler (that one fetches a Page; winter charts are not Pages). */
(function () {
  'use strict';
  var btn = document.querySelector('[data-winter-guide]');
  var modal = document.querySelector('[data-winter-sg]');
  if (!btn || !modal) return;
  var lastFocus = null;
  var close = modal.querySelector('.sg__close');

  function open() {
    lastFocus = document.activeElement;
    if (modal.parentNode !== document.body) document.body.appendChild(modal); // escape any transformed ancestor
    modal.hidden = false;
    void modal.offsetWidth;                 // flush layout so the transition runs
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    close.focus();
  }
  function shut() {
    modal.classList.remove('is-open');
    modal.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  btn.addEventListener('click', open);
  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-winter-close]')) shut();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) shut();
  });
})();
